import { render, staticRenderFns } from "./BalanceCard.vue?vue&type=template&id=33993db6&scoped=true"
import script from "./BalanceCard.vue?vue&type=script&lang=js"
export * from "./BalanceCard.vue?vue&type=script&lang=js"
import style0 from "./BalanceCard.vue?vue&type=style&index=0&id=33993db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33993db6",
  null
  
)

export default component.exports